import { ADMIN_ROLES, HELP_AND_SUPPORT_ADMIN } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

import { AuthController } from '../auth-controller';

export class AdminHelpAndSupportController extends AuthController {
  public pageId = HELP_AND_SUPPORT_ADMIN;
  public path = '/admn/help';
  public routeName = 'helpAndSupport';
  public bundles = [];
  public pageTitle = 'controllers.helpAndSupport';
  public isAdminView = true;
  public accessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_SALES,
  ];
  public navIcon = 'help';

  public component = codeSplit(
    () => import(/* webpackChunkName: "adminHelpAndSupport" */ '../../views/admin/admin-help-and-support'),
  );
  public exact = true;
}
